import React from 'react';

export default ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width="20"
    height="14"
    viewBox="0 0 20 14"
  >
    <path d="M18.2928932,0.292893219 C18.6834175,-0.0976310729 19.3165825,-0.0976310729 19.7071068,0.292893219 C20.0675907,0.65337718 20.0953203,1.22060824 19.7902954,1.61289944 L19.7071068,1.70710678 L7.70710678,13.7071068 C7.34662282,14.0675907 6.77939176,14.0953203 6.38710056,13.7902954 L6.29289322,13.7071068 L0.292893219,7.70710678 C-0.0976310729,7.31658249 -0.0976310729,6.68341751 0.292893219,6.29289322 C0.65337718,5.93240926 1.22060824,5.90467972 1.61289944,6.20970461 L1.70710678,6.29289322 L7,11.585 L18.2928932,0.292893219 Z" />
  </svg>
);
